import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-scripts',
  templateUrl: './footer-scripts.component.html',
  styleUrls: ['./footer-scripts.component.scss']
})
export class FooterScriptsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
